import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopConfirm from '@omilia/popconfirm';

import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';
import { ruleGroupType } from 'types';

class RuleGroupInspectHeader extends Component {
  static propTypes = {
    currentGroup: ruleGroupType.isRequired,
    selectedTabIndex: PropTypes.number,
    onDelete: PropTypes.func,
    onOpenAddRuleModal: PropTypes.func,
  };

  handleDelete = () => {
    const {
      currentGroup: { id },
      onDelete,
    } = this.props;

    onDelete(id);
  };

  handleAdd = () => {
    this.props.onOpenAddRuleModal(
      this.props.currentGroup.id,
      this.props.currentGroup.rules.length,
      this.props.currentGroup.order,
    );
  };

  renderGeneralTabButtons = () => {
    const {
      selectedTabIndex,
      currentGroup: { archived },
    } = this.props;

    if (selectedTabIndex !== 1 || archived) {
      return null;
    }
    return (
      <PopConfirm
        body="Are you sure you want to delete this group?"
        placement="left"
        confirmLabel="Yes"
        declineLabel="Cancel"
        onConfirm={this.handleDelete}
      >
        <InspectButton isHeader data-test="delete-rule-group">
          Delete Rule Group
        </InspectButton>
      </PopConfirm>
    );
  };

  renderAddRuleTabButton = () => {
    const {
      selectedTabIndex,
      currentGroup: { archived },
    } = this.props;
    if (selectedTabIndex !== 2 || archived) {
      return null;
    }

    return (
      <InspectButton
        isHeader
        onClick={this.handleAdd}
        data-test="add-rule-button"
      >
        + Add Rule
      </InspectButton>
    );
  };

  render() {
    return (
      <InspectHeader>
        {this.renderGeneralTabButtons()}
        {this.renderAddRuleTabButton()}
      </InspectHeader>
    );
  }
}

export default RuleGroupInspectHeader;
